import { useEffect, useState } from 'react';
import { isUiThemeDark, type UiThemePreference } from '@/lib/institution-player-branding';
import { useUIStore } from '@/stores/ui.store';

/** Aligné sur `applyThemeToDocument` : dark explicite ou préférence système. */
export function useUiThemeDark(): boolean {
  const theme = useUIStore((s) => s.theme) as UiThemePreference;
  const [prefersDark, setPrefersDark] = useState(() => {
    if (typeof window === 'undefined') return false;
    return window.matchMedia('(prefers-color-scheme: dark)').matches;
  });

  useEffect(() => {
    const mq = window.matchMedia('(prefers-color-scheme: dark)');
    const onChange = () => setPrefersDark(mq.matches);
    onChange();
    mq.addEventListener('change', onChange);
    return () => mq.removeEventListener('change', onChange);
  }, []);

  return isUiThemeDark(theme, prefersDark);
}
